<template>
  <div class="conteudoInterno" id="distribuicao">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState,
      }">
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Distributions</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPinkBack"></span>
        </div>
        <div class="col66 top32">
          <p>
            The main objective of the collective management system is to pay rightsholders for the use of their works.
            To achieve this, we must be accurate, efficient, transparent, and timely.
          </p>
          <p>
            As UBC represents some of the world’s largest and most active repertoires, both domestic and international,
            its internal infrastructure and its integration with ECAD are continuously evolving to keep pace with
            demand, without ever compromising the services and resources we provide.
          </p>
          <p>The figures below are again based on ECAD’s total data, in order to accurately reflect the overall
            Brazilian market. We reiterate that the final section of this report presents UBC-specific figures.</p>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            The total amount distributed in 2025 was <span class="ubcPink Green sanukBlack">BRL 1.725 billion</span>,
            representing a <span class="ubcPink Green sanukBlack">9.95% increase</span> compared to 2024.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col32">
          <h3>Distribution figures over time</h3>

          <div class="evolucaoDistribuicao top20">
            <span>2021</span>
            <h4 class="sanukBlack ubcPink">BRL 901.6 million</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2022</span>
            <h4 class="sanukBlack ubcPink">BRL 1.232 billion</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2023</span>
            <h4 class="sanukBlack ubcPink">BRL 1.391 billion</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2024</span>
            <h4 class="sanukBlack ubcPink">BRL 1.569 billion</h4>
          </div>
          <div class="evolucaoDistribuicao ">
            <span>2025</span>
            <h4 class="sanukBlack ubcPink">BRL 1.725 billion</h4>
          </div>
          <p class="top32">
            In 2025, <span class="sanukBold">more than 345,000 rightsholders received distributions</span>. In the
            authors’ segment, <span class="sanukBold">77% of recipients were domestic</span> and <span
              class="sanukBold">23% foreign</span>. In the related rights segment, <span class="sanukBold">80% were
              domestic</span> and <span class="sanukBold">20% foreign</span>.
          </p>
        </div>
        <div class="col57ponto6 topMob32">
          <h3>Distribution by segment</h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <BarChart />
              <!-- <BarsChartDistribuicao /> -->
            </div>
          </div>

        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col100">
          <h3>
            Breakdown of distribution by rights type:
          </h3>
          <SwipperMobile />
          <div class="top20 tableContainer">
            <table>
              <thead>
                <tr>
                  <th align="left">
                    <span class="sanukBold">Segments</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">2024</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">%</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">2025</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">%</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">Change (BRL)</span>
                  </th>
                  <th align="center">
                    <span class="sanukBold">Change (%)</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                
                <tr>
                  <td>Carnival</td>
                  <td align="right">BRL 24,636,572.30</td>
                  <td align="right">1.57%</td>
                  <td align="right">BRL 33,217,093.44</td>
                  <td align="right">1.92%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 8,580,521.14</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">34.83%</span></td>
                </tr>
                <tr>
                  <td>Clubs</td>
                  <td align="right">BRL 49,258,610.41</td>
                  <td align="right">3.14%</td>
                  <td align="right">BRL 55,427,385.48</td>
                  <td align="right">3.21%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 6,168,775.07</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">12.52%</span></td>
                </tr>
                <tr>
                  <td>Cinema</td>
                  <td align="right">BRL 42,174,748.89</td>
                  <td align="right">2.69%</td>
                  <td align="right">BRL 30,992,400.34</td>
                  <td align="right">1.80%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL -11,182,348.55</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">-26.51%</span></td>
                </tr>
                <tr>
                  <td>June Festivals</td>
                  <td align="right">BRL 6,104,228.09</td>
                  <td align="right">0.39%</td>
                  <td align="right">BRL 8,568,176.94</td>
                  <td align="right">0.50%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 2,463,948.85</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">40.36%</span></td>
                </tr>
                <tr>
                  <td>Live Music (small venues)</td>
                  <td align="right">BRL 43,605,345.92</td>
                  <td align="right">2.78%</td>
                  <td align="right">BRL 52,757,589.41</td>
                  <td align="right">3.06%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 9,152,243.49</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">20.99%</span></td>
                </tr>
                <tr>
                  <td>Radios + General distrib.</td>
                  <td align="right">BRL 295,484,391.75</td>
                  <td align="right">18.82%</td>
                  <td align="right">BRL 319,319,836.39</td>
                  <td align="right">18.50%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 23,835,444.64</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">8.07%</span></td>
                </tr>
                <tr>
                  <td>Digital Services</td>
                  <td align="right">BRL 9,490,696.65</td>
                  <td align="right">0.60%</td>
                  <td align="right">BRL 10,165,829.42</td>
                  <td align="right">0.59%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 675,132.77</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">7.11%</span></td>
                </tr>
                <tr>
                  <td>Live Concerts</td>
                  <td align="right">BRL 219,368,656.74</td>
                  <td align="right">13.98%</td>
                  <td align="right">BRL 254,058,991.38</td>
                  <td align="right">14.72%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 34,690,334.64</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">15.81%</span></td>
                </tr>
                <tr>
                  <td>Background Music</td>
                  <td align="right">BRL 68,614,036.78</td>
                  <td align="right">4.37%</td>
                  <td align="right">BRL 73,395,424.03</td>
                  <td align="right">4.25%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 4,781,387.25</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">6.97%</span></td>
                </tr>
                <tr>
                  <td>Audio streaming</td>
                  <td align="right">BRL 163,026,643.72</td>
                  <td align="right">10.39%</td>
                  <td align="right">BRL 174,420,206.12</td>
                  <td align="right">10.11%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 11,393,562.40</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">6.99%</span></td>
                </tr>
                <tr>
                  <td>Video streaming</td>
                  <td align="right">BRL 199,812,236.72</td>
                  <td align="right">12.73%</td>
                  <td align="right">BRL 231,720,040.43</td>
                  <td align="right">13.43%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 31,907,803.71</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">15.97%</span></td>
                </tr>
                <tr>
                  <td>Free-to-air TV + General distrib.</td>
                  <td align="right">BRL 254,848,703.19</td>
                  <td align="right">16.24%</td>
                  <td align="right">BRL 268,535,688.44</td>
                  <td align="right">15.56%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL 13,686,985.25</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">5.37%</span></td>
                </tr>
                <tr>
                  <td>Pay TV</td>
                  <td align="right">BRL 193,233,551.23</td>
                  <td align="right">12.31%</td>
                  <td align="right">BRL 191,484,997.50</td>
                  <td align="right">11.10%</td>
                  <td align="right"><span class="sanukBold ubcBlue">BRL -1,748,553.73</span></td>
                  <td align="right"><span class="sanukBold ubcBlue">-0.90%</span></td>
                </tr>
                <tr class="sanukBold">
                  <td>Total</td>
                  <td align="right">BRL 1,569,658,422.39</td>
                  <td align="right"> </td>
                  <td align="right">BRL 1,725,642,718.57</td>
                  <td align="right"></td>
                  <td align="right"><span class=""></span></td>
                  <td align="right"><span class=""></span></td>
                </tr>
                <tr>
                  <td>Other segments*</td>
                  <td align="right" class="sanukBold ">BRL -283,909.57</td>
                  <td align="right"></td>
                  <td align="right" class="sanukBold ">BRL -145,717.67</td>
                  <td align="right"></td>
                  <td align="right"><span class="sanukBold"></span></td>
                  <td align="right"><span class="sanukBold"></span></td>
                </tr>
                <tr class="sanukBold">
                  <td>Total including other segments</td>
                  <td align="right">BRL 1,569,374,512.82</td>
                  <td align="right"></td>
                  <td align="right">BRL 1,725,497,000.90</td>
                  <td align="right"></td>
                  <td align="right"><span class=""></span></td>
                  <td align="right"><span class=""></span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tableNote">
            <span class="sanukBold">*Other segments:</span>“Indirect – Up to Nov/97”; “Court-Ordered Withholding”; “Rightsholder Debt”; “Former General Rights”; and “Former Session Musician”.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
import BarChart from "./Grafico4.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "Distributions-Page",
  props: ["clicked"],
  components: {
    BarChart,
    // BarsChartDistribuicao,
    SwipperMobile,
  },
  data() {
    return {
      setaScrollState: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#distribuicao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.evolucaoDistribuicao h4 {
  font-size: 24px;
  margin-bottom: 8px;
}

.evolucaoDistribuicao:nth-child(3) h4 {
  font-size: 27px;
  margin-bottom: 8px;
}

.evolucaoDistribuicao:nth-child(4) h4 {
  font-size: 30px;
  margin-bottom: 8px;
}

.evolucaoDistribuicao:nth-child(5) h4 {
  font-size: 33px;
  margin-bottom: 8px;
}

.evolucaoDistribuicao:nth-child(6) h4 {
  font-size: 36px;
}

.note {
  padding-left: 160px;
}

.graphContainer {
  padding-top: 30px;
  width: 100%;
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar {
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb {
  background-color: #ec1651;
  border-radius: 10px;
  border: 5px solid white;
}

.graph {
  /* min-width: 700px; usando o grafico de barras empilhadas */
  min-width: 500px;
  /*em caso de usar o grafico de barras*/
  min-height: 400px;
}

table {
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  font-size: 14px;
  min-width: 1024px;
}

table thead {
  background-color: #ec1651;
  color: #fff;
}

table thead tr th {
  padding: 15px 0;
  vertical-align: middle;
}

table thead tr th:first-child {
  padding-left: 2%;
}

table thead tr th:last-child {
  padding-right: 2%;
}

table tbody tr:nth-child(even) {
  background-color: #f6f6f6;
}

table tbody tr td {
  padding: 15px 0;
  vertical-align: middle;
  font-size: 12px;
}

table tbody tr {
  position: relative;
}

table tbody tr td:first-child {
  padding-left: 2%;
  position: sticky;
  left: 0;
  background: #fff;
}

table tbody tr:nth-child(even) td:first-child {
  background-color: #f6f6f6;
}

table tbody tr td:last-child {
  padding-right: 2%;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.subColYear {
  font-family: "sanuk-bold";
  
}


@media screen and (max-width: 1200px) {
  .tableContainer {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 500px) {
  .note {
    padding-left: 0;
  }
}
</style>
